import { render, staticRenderFns } from "./backSite.vue?vue&type=template&id=afedbb14&scoped=true&"
import script from "./backSite.vue?vue&type=script&lang=ts&"
export * from "./backSite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afedbb14",
  null
  
)

export default component.exports